import DetailHeader from "./DetailHeader";

const Header = (props) =>{
    const {headerTitle, arrowYn, closeYn} = props;

    return(
        <div id="headerWrap" className="boxType1">
            <DetailHeader headerTitle={headerTitle} arrowYn={arrowYn} closeYn={closeYn}/>
        </div>
    )
}
export default Header;